<template>
    <div v-if="showCoupons">
        <div class="divider--container background--paper clear--sm">
            <div class="divider-white--top"></div>
            <div class="divider-white--bottom"></div>
        </div>
        <div class="couponHistory" :style=customStyles>
            <h2 v-if="showExpired">{{$t('APP_COUPON_HISTORY_MANAGE_ACCOUNT')}}</h2>
            <h2 v-else>{{$t('APP_COUPON_HISTORY')}}</h2>
            <table>
                <thead>
                    <tr>
                        <th>{{$t('APP_COUPON_HISTORY_DISCOUNT')}}</th>
                        <th>{{$t('APP_COUPON_HISTORY_APPLIED_TO')}}</th>
                        <th>{{$t('APP_COUPON_HISTORY_STATUS')}}</th>
                        <th>{{$t('APP_COUPON_HISTORY_EXPIRY_DATE')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(coupon, index) in displayCoupons" :key="index">
                        <td>{{coupon.discount}}</td>
                        <td>{{$t(coupon.product_type)}}</td>
                        <td :class="coupon.status">{{coupon.status === 'Used' ? `Used on ${coupon.used_on}` : coupon.status}}</td>
                        <td v-text="getExpiringDays(coupon)"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import * as Dates from '@/constants/Dates';
import { formatDate } from '@/helpers/DateHelpers';

export default {
    name: 'CouponHistory',
    props: {
        customStyles: {
            type: Object,
            required: false,
        },
        showExpired: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        showCoupons() {
            return this.displayCoupons.length > 0;
        },
        coupons() {
            return this.$store.getters['account/getCouponsHistory'];
        },
        displayCoupons() {
            if (this.showExpired) {
                return this.coupons.filter((coupon) => ['Active', 'Expired', 'Used'].includes(coupon.status));
            } else {
                return this.coupons.filter((coupon) => coupon.status === 'Active');
            }
        },
    },
    mounted() {
        this.$store.dispatch('account/fetchCouponsHistory');
    },
    methods: {
        getExpiringDays(couponData) {
            return couponData?.expires_on ? formatDate(new Date(couponData?.expires_on), Dates.UK_DATE_FORMAT) : '-';
        },
    },
};
</script>

<style lang="scss" scoped>
.couponHistory {
    padding: 40px 0;
    text-align: center;
    position: relative;
    table {
        width: 80%;
        max-width: 600px;
        margin: 20px auto;
        border-collapse: collapse;
        td, th {
            padding: 0.25em .55em;
            font-weight: lighter;
        }
        th {
            font-weight: normal;
            white-space: nowrap;
        }
        td {
            border-top: 1px solid theme('colors.grey.200');
        }
    }
    .Active {
        background: theme('colors.shop.green');
    }
    .Used {
        background: theme('colors.grey.300');
    }
}
</style>
